module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\"><path fill=\"#7A8291\" d=\"M147,10 L157,10 L157,22 L147,22 L147,10 Z M149,10 L149,15 L155,15 L155,10 L149,10 Z M149,17 L149,22 L155,22 L155,17 L149,17 Z M161.068,22 L161.068,16.305 L161.042,16.305 L159.43,17.072 L159.105,15.59 L161.341,14.55 L162.979,14.55 L162.979,22 L161.068,22 Z\" transform=\"translate(-144 -6)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/h1.svg
// module id = 757
// module chunks = 0